import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { RotateRightIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useLocation } from "@aviv-unified-frontend/runtime/router";
import { useTranslate } from "../../../utils/useTranslate";
const fullWidth = {
    "breakpoint.base": true,
    "breakpoint.sm": false,
};
export const GeneralErrorPageButtons = () => {
    const { pathname, search, hash } = useLocation();
    const t = useTranslate();
    return (_jsxs(Box, { paddingHorizontal: { "breakpoint.base": "spacing.16" }, display: "inline-flex", flexDirection: "column", alignItems: "center", alignSelf: "stretch", gap: "spacing.12", children: [_jsx(Button, { variant: "primary", isFullWidth: fullWidth, icon: RotateRightIcon, iconPosition: "start", href: pathname + search + hash, children: t("generalError.primaryButton") }), _jsx(Button, { variant: "tertiary", href: "/", isFullWidth: fullWidth, children: t("generalError.secondaryButton") })] }));
};
